import { print } from "graphql";
import type {
  GetCollectionSiteFromNamesQuery,
  GetCollectionSiteFromNamesQueryVariables,
} from "../../generated/graphql";
import { authedFetcher } from "./gql-client";
import { getOrgAndSiteFromNamesDocument } from "./graphql";

export const getOrgAndSiteFromNames = authedFetcher<
  GetCollectionSiteFromNamesQueryVariables,
  GetCollectionSiteFromNamesQuery
>(print(getOrgAndSiteFromNamesDocument))("GetCollectionSiteFromNames");
